$(document).ready(function() {
    $('.recipe-archive-time').on("change",function() {
        $(".recipe-archive-time").addClass("select-box-arrow");
    });
});


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/scripts/partials/recipe-time.js
// module id = 34
// module chunks = 0